'use client'

import { type PropsWithChildren } from 'react'

import { CookieConsentProvider } from '@graftcode/design-system'

import { CookieBannerGuard } from '../components/CookieBannerGuard/CookieBannerGuard'
import { GtmConsentSync } from '../components/GtmConsentSync/GtmConsentSync'
import { Loader } from '../components/Loader/Loader'

interface LayoutProviderProps extends PropsWithChildren {
  initialLoading?: boolean
  cookieDomain?: string
}

export function LayoutProvider({ children, cookieDomain }: LayoutProviderProps) {
  return (
    <>
      <Loader />
      <CookieConsentProvider cookieDomain={cookieDomain}>
        <GtmConsentSync />
        <CookieBannerGuard />
        {children}
      </CookieConsentProvider>
    </>
  )
}
